import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { ScreenHeader } from "../UI/Elements"
import { AdminIcon, AdminIcons } from "../Shared/AdminIcon"
import { CustomColumnContainer } from '../Shared/Formelements';
import { Data } from '../../Handlers/Data';
import { MessageBoxes } from '../../Handlers/MessageBoxes';
import { simulateDelay } from '../../Handlers/Helpers';
import { FetchHandler } from '../../Handlers/FetchHandler';
import { Overlay } from '../UI/Overlay';
import { useUsers } from '../../hooks/useUsers';

export const GamificationScreen = () => {
    const ui = useGamificationScreen();

    const users = useUsers();

    useEffect(() => {
        ui.load();
    }, []);

    const [reportVisible, setReportVisible] = useState<boolean>(false);
    const [reportLoading, setReportLoading] = useState<boolean>(false);

    const [reportData, setReportData] = useState<GamificationAcievementReportItemType[]>([]);
    const [reportfilterMinPoints, setReportfilterMinPoints] = useState<number>(20);
    const [visibleUsers, setVisibleUsers] = useState<GamificationAcievementReportItemType[]>([]);

    useEffect(() => {
        const temp = reportData?.filter(m => m.points >= reportfilterMinPoints);
        setVisibleUsers(temp);
        users.ensureUserInfo(temp.map(m => m.userId));
    }, [, reportData, reportfilterMinPoints]);


    return (
        <div className="gamification-screen">
            <ScreenHeader text="Gamification" icon={AdminIcons.calendarCheck} />
            <CustomColumnContainer gridTemplateColumns={'250px 250px auto 180px'}>
                <div>
                    <label>År</label>
                    <Select
                        value={ui.yearsOptions.find(m => m.value == ui.selectedYear)}
                        options={ui.yearsOptions}
                        onChange={e => ui.setSelectedYear(e.value)}
                        isDisabled={false}
                    />
                </div>


                <div>
                    <label>Månad</label>
                    <Select
                        value={ui.monthsOptions.find(m => m.value == ui.selectedMonth)}
                        options={ui.monthsOptions}
                        onChange={e => ui.setSelectedMonth(e.value)}
                        isDisabled={false}
                    />
                </div>
                <div>

                </div>
                <div>
                    <button className='btn' onClick={async () => {
                        setReportVisible(true);
                        setReportLoading(true);
                        const s = await ui.getReport();
                        setReportData(s);
                        setReportLoading(false);

                    }}>Rapport för {ui.monthsOptions.find(m => m.value == ui.selectedMonth)?.labelclean}</button>
                </div>
            </CustomColumnContainer>
            <hr />
            <div>
                <table className='tbl'>
                    <thead>
                        <tr>
                            <th>Period</th>
                            <th>Text</th>
                            <th>Poäng</th>
                            <th>Foto</th>
                            <th>Bara premium</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {ui.data?.map(i => (
                            <ItemRow key={i?.id}
                                achvievement={i}
                                onDelete={() => ui.remove(i?.id)}
                                onUpsert={e => ui.upsert({ ...e })}
                                onSave={() => ui.onSave(i)}
                            />
                        ))}
                    </tbody>
                </table>
            </div>
            <div>
                <button className='btn' onClick={() => {
                    ui.upsert({
                        id: "",
                        name_sv: "Ny....(se)",
                        name_no: "Ny....(no)",
                        name_en: "Ny....(en)",
                        month: 0, year: 0, points: 1,
                    })
                }}>Lägg till</button>

            </div>
            {/* <div>
                {JSON.stringify(ui.rawData)}
            </div> */}

            <div>
                <Overlay visible={reportVisible} />
                {reportVisible && (
                    <div className='reportsheet-container'>
                        <div className='filters'>
                            <div>
                                <label>Minst antal poäng</label>
                                <input
                                    type='number'
                                    value={reportfilterMinPoints}
                                    onChange={e => setReportfilterMinPoints(e.target.valueAsNumber)}
                                />
                            </div>

                            <div>
                                <button className='btn' onClick={() => {
                                    var table = document.getElementById("reporttable");

                                    if (navigator.clipboard) {
                                        var text = table.innerText.trim();
                                        navigator.clipboard.writeText(text).catch(function () { });
                                        MessageBoxes.info("Tabellen kopierades!");
                                    }

                                }}>Kopiera data i rapport</button>
                            </div>

                            <div>
                                <button className='btn' onClick={() => {
                                    setReportVisible(false);
                                }}>Stäng rapport</button>
                            </div>

                        </div>
                        <hr />
                        <div className='reportsheet'>
                            <table id="reporttable" className='tbl'>
                                <thead>
                                    <tr>
                                        <th>Namn ({visibleUsers?.length} st)</th>
                                        <th>Email</th>
                                        <th>Frön</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {reportLoading == false && visibleUsers.map((i, idz) => (
                                        <tr key={i?.userId}>
                                            <td>
                                                {users.getUsersName(i?.userId)}
                                            </td>
                                            <td>
                                                {users.getUsersEmail(i?.userId)}
                                            </td>
                                            <td>
                                                {i?.points}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            {reportLoading && (
                                <div>
                                    Laddar...
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>


        </div>
    )
}

const ItemRow = ({ achvievement, onUpsert, onDelete, onSave }: { achvievement: GamificationAcievementType, onUpsert(e: GamificationAcievementType): void, onDelete(e: string): void, onSave(): void }) => {

    const [editing, setEditing] = useState<boolean>(!achvievement?.id);

    return (
        <tr>
            <td>
                {achvievement?.year}-{achvievement?.month}
            </td>
            <td>
                {!!editing && (
                    <div>
                        <input type='text' placeholder='Svenska' defaultValue={achvievement?.name_sv} onChange={e => onUpsert({ ...achvievement, name_sv: e.target.value })} />
                        <br />
                        <input type='text' placeholder='Norska' defaultValue={achvievement?.name_no} onChange={e => onUpsert({ ...achvievement, name_no: e.target.value })} />
                        <br />
                        <input type='text' placeholder='Engelska' defaultValue={achvievement?.name_en} onChange={e => onUpsert({ ...achvievement, name_en: e.target.value })} />
                    </div>
                )}
                {!editing && (
                    <span>
                        se:{achvievement?.name_sv},
                        <br />
                        no:{achvievement?.name_no},
                        <br />
                        en:{achvievement?.name_en},
                    </span>
                )}
            </td>
            <td>
                {!!editing && (
                    <input
                        type='number'
                        value={achvievement?.points}
                        onChange={e => onUpsert({ ...achvievement, points: Math.max(1, Math.min(10, e.target.valueAsNumber)) })}
                        min={1} max={10} step={1}
                    />
                )}
                {!editing && (
                    <span>
                        {achvievement?.points}
                    </span>
                )}
            </td>
            <td>
                {!!editing && (
                    <input
                        type='checkbox'
                        checked={achvievement?.isphoto ?? false}
                        onChange={e => onUpsert({ ...achvievement, isphoto: e.target.checked })}
                    />
                )}
                {!editing && (
                    <span>
                        {achvievement?.isphoto ? "Ja" : ""}
                    </span>
                )}
            </td>
            <td>
                {!!editing && (
                    <input
                        type='checkbox'
                        checked={achvievement?.ispremiumonly ?? false}
                        onChange={e => onUpsert({ ...achvievement, ispremiumonly: e.target.checked })}
                    />
                )}
                {!editing && (
                    <span>
                        {achvievement?.ispremiumonly ? "Ja" : ""}
                    </span>
                )}
            </td>
            <td style={{ textAlign: "right" }}>
                <button className='btn' onClick={() => {
                    setEditing(!editing);
                    if (!!editing && !!onSave) {
                        onSave()
                    }
                }} >{editing ? "Spara" : "Redigera"}</button>
                <button className='btn' onClick={() => onDelete(achvievement?.id)} >Radera</button>
            </td>
        </tr>
    )
}


type GamificationAcievementType = {
    id?: string
    name_sv?: string
    name_no?: string
    name_en?: string
    year?: number
    month?: number,
    points?: number
    isphoto?: boolean
    ispremiumonly?: boolean
}
type GamificationAcievementReportItemType = {
    userId: string
    datekey: number
    key: string
    points: number
    sys_datecreated_utc_epoch: number
}


export const useGamificationScreen = () => {


    const api = useGamificationScreenApi();
    const [rawData, setRawData] = useState<Record<string, GamificationAcievementType>>({});


    const load = async () => {
        const d: GamificationAcievementType[] = await api.getAll();
        let ch = {};
        d.forEach(c => ch[c?.id] = c);
        setRawData(ch);
    }

    const years: number[] = [
        new Date().getFullYear() - 1,
        new Date().getFullYear(),
        new Date().getFullYear() + 1,
        new Date().getFullYear() + 2,
        new Date().getFullYear() + 3,
        new Date().getFullYear() + 4
    ];
    const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth() + 1);
    const months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    const monthNames = Data.monthNamesShort;


    useEffect(() => {
        if (!!rawData) {
            setData(
                Object
                    .keys(rawData).map(key => rawData[key])
                    .filter(m => m.month === selectedMonth && m.year === selectedYear)
            );
        }
    }, [, rawData, selectedMonth, selectedYear]);

    const [data, setData] = useState<GamificationAcievementType[]>([]);

    return {
        load: load,
        data: data,
        rawData: rawData,

        years: years,
        yearsOptions: years.map(y => { return { value: y, label: y } }),
        selectedYear: selectedYear, setSelectedYear: setSelectedYear,

        months: months,
        monthsOptions: months.map(y => {
            const count = Object
                .keys(rawData).map(key => rawData[key])
                .filter(m => m.month === y && m.year === selectedYear)?.length ?? 0

            return {
                value: y,
                label: monthNames[y - 1] + (count > 0 ? " (" + count + ")" : ""),
                labelclean: monthNames[y - 1]
            }
        }),
        selectedMonth: selectedMonth, setSelectedMonth: setSelectedMonth,

        upsert: (e: GamificationAcievementType) => {
            setRawData({ ...rawData, [e?.id]: { ...e, month: selectedMonth, year: selectedYear } });
        },
        onSave: async (e: GamificationAcievementType) => {
            await api.onSave(e);
            await load();
        },
        remove: async (id: string) => {
            if (MessageBoxes.confirm("Radera '" + rawData?.[id]?.name_sv + "'?")) {
                let ch = { ...rawData };
                if (!!ch[id]) {
                    delete ch[id];
                    setRawData(ch);
                }

                await api.remove(id);
                await load();

            }
        },
        getReport: async () => {
            return await api.getReport(selectedYear, selectedMonth);
        }

    }
}


const useGamificationScreenApi = () => {
    const add = async (e: GamificationAcievementType): Promise<boolean> => {
        return await FetchHandler.postJson("/api/gamification/monthly", e)
    }
    const update = async (e: GamificationAcievementType): Promise<boolean> => {
        return await FetchHandler.patchJson("/api/gamification/monthly/" + e?.id, e)
    }
    const remove = async (id: string): Promise<boolean> => {
        return await FetchHandler.delete("/api/gamification/monthly/" + id)
    }
    const getReport = async (year: number, month: number): Promise<GamificationAcievementReportItemType[]> => {
        const url = "/api/gamification/userreport/month/sum?year=" + year + "&month=" + month;

        return await FetchHandler.getJson(url);
    }

    return {
        getReport,
        getAll: async (): Promise<GamificationAcievementType[]> => {
            return await FetchHandler.getJson("/api/gamification/monthly")
        },
        onSave: async (e: GamificationAcievementType) => {
            if (!!e?.id) {
                return await update(e);
            } else {
                return await add(e);
            }
        },
        remove: async (id: string) => {
            return remove(id);
        }
    }
}